import { useRef, useState } from "react"
import JWTApi from "../../libs/login/JWTApi"
import {useSnackbar} from "../Snackbar/SnackbarProvider"
import Tabs from "../Tabs/Tabs"
import { useForm } from "../Form/Form"
import Button from "../Button/Button"
import LoginForm, { ILoginForm } from "./LoginForm"
import SignupForm, { ISignupForm } from "./SignupForm"
import { useOverlay } from "../Overlay/OverlayProvider"

export interface TLoginDlgProps {
    overlayId?:string
    api:JWTApi
    onLogin?:Function
}

const LOGIN_TABS = [{id:"login",text:"Login"}, {id:"signup",text:"Signup"}]
export default function LoginDlg(props:TLoginDlgProps){
    const {api} = props
    const [tab,setTab] = useState<string>("login")
    const {addSnackbar} = useSnackbar()
    const [busy,setBusy] = useState<boolean>(false)
    const {dirty, valid, setDirty} = useForm()
    const loginForm = useRef<ILoginForm|null>(null)
    const signupForm = useRef<ISignupForm|null>(null)
    const {popOverlay} = useOverlay()

    const onLogin = async () => {
        if (!dirty) setDirty(true)

        if (!valid || busy) return
        else setBusy(true)

        try {
            if (tab=="login") await api.login(loginForm.current!.email, loginForm.current!.password)
            else await api.register(signupForm.current!.email, signupForm.current!.password, signupForm.current!.name)
            popOverlay(props.overlayId)
            props.onLogin?.()
        }catch(e){
            setBusy(false)
            addSnackbar(e)
        }
    }
    return <>
        <div className="title">
            <Tabs options={LOGIN_TABS} onTab={tab => setTab(tab)} defaultValue="login"/>
        </div>
        <div className="content" key={tab}>
            {tab=="login" ? <LoginForm ref={loginForm} onSubmit={onLogin}/> : <SignupForm ref={signupForm} onSubmit={onLogin}/>}
        </div>
        <div className="actions">
            <Button variant="contained" onClick={onLogin} disabled={busy || !valid}>{tab=="login" ? "Login" : "Create"}</Button>
        </div>
    </>
}
